"use strict";
/**
 * # FS Protocol
 *
 * The filesystem protocol revolves around sending and receiving operations to
 * update the {@link MemoryFS} instance on Pitcher's clients and server.
 * This allows operations to be conflict resolving by the commutative and
 * monotonic properties of MemoryFS's CRDT tree structure.
 *
 * ## Load Project
 *
 * To populate MemoryFS with an initial snapshot of the project's files, we send
 * {@link LoadProject} to request the list of MemoryFS nodes and children. These
 * contain the file paths, ids, metadata, but _not_ the file contents.
 *
 * This allows us to operate on files by their ids, allowing us not to worry
 * about their name or path at any given moment in time.
 *
 * ## Operations
 *
 * To inform the server of new filesystem operations, {@link SendOps} is used to
 * send a list of {@link OpMove}s generated by MemoryFS.
 *
 * To keep the client up-to-date, the {@link ListenOps} is used to subscribe to
 * new operations sent by other clients to the server, which can then be applied
 * to the client's MemoryFS.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSOperationResponseCode = void 0;
var FSOperationResponseCode;
(function (FSOperationResponseCode) {
    FSOperationResponseCode[FSOperationResponseCode["Success"] = 0] = "Success";
    FSOperationResponseCode[FSOperationResponseCode["Ignored"] = 1] = "Ignored";
})(FSOperationResponseCode || (exports.FSOperationResponseCode = FSOperationResponseCode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbWVzc2FnZXMvZnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBeUJHOzs7QUFxR0gsSUFBWSx1QkFHWDtBQUhELFdBQVksdUJBQXVCO0lBQ2pDLDJFQUFXLENBQUE7SUFDWCwyRUFBVyxDQUFBO0FBQ2IsQ0FBQyxFQUhXLHVCQUF1Qix1Q0FBdkIsdUJBQXVCLFFBR2xDIn0=